(() => {
  const plainSku = /^\d{6}$/;
  const prefix = 'variants.sku:';

  const searchInput = (target) =>
    target instanceof HTMLInputElement &&
    target.name === 'q' &&
    target.closest('form[action*="/search"]');

  const nativeFetch = window.fetch.bind(window);
  window.fetch = (resource, options) => {
    try {
      const source = typeof resource === 'string' ? resource : resource.url;
      const url = new URL(source, window.location.origin);
      const value = url.searchParams.get('q')?.trim();
      if (url.pathname.includes('/search/suggest') && value && plainSku.test(value)) {
        url.searchParams.set('q', `${prefix}${value}`);
        resource = typeof resource === 'string' ? url.toString() : new Request(url, resource);
      }
    } catch (error) {
      console.warn('No fue posible normalizar la búsqueda por SKU.', error);
    }
    return nativeFetch(resource, options);
  };

  document.addEventListener('submit', (event) => {
    const input = event.target?.querySelector?.('input[name="q"]');
    if (!input) return;

    const value = input.value.trim();
    if (plainSku.test(value)) input.value = `${prefix}${value}`;
  }, true);
})();
